<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <detail-row-component title="품종 이름" :inner-vertical="true">

          <layout-input v-model="editable.name"
                        :regex="regex(1, 100).ko_num"
                        placeHolder="한글 이름을 입력해주세요."/>

          <layout-input v-model="editable.nameEn"
                        :regex="regex(1, 100).en_num"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="간단한 품종 설명">

          <layout-input v-model="editable.grapeDscSubtitle"
                        :regex="regex(1, 100).ko_en_num"
                        placeHolder="간단한 품종 설명을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="품종 설명">

          <layout-textarea v-model="editable.grapeDsc"
                           placeHolder="품종 설명을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="품종 이미지" innerVertical>

          <layout-image-selector v-model="editable.imgGrape"
                                 :index="`image_grape${rowData.id}`"
                                 :on-image-out-of-size="onImageOutOfSize"/>
          <layout-info title="* 품종 이미지 최대 사이즈 : 600 X 1200" infoType="warn"/>

        </detail-row-component>

        <detail-row-component title="발행">

          <layout-switch-button v-model="editable.isChecked"/>

        </detail-row-component>

      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';

import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';

import LayoutInput from '@/spa/components/LayoutInput';
import LayoutImageSelector from '@/spa/components/LayoutImageSelector';
import LayoutTextarea from '@/spa/components/LayoutTextarea';
import LayoutSwitchButton from '@/spa/components/LayoutSwitchButton';
import LayoutInfo from '@/spa/components/LayoutInfo';

export default {
  name: 'GrapeEditor',
  components: {
    DetailRowWrapper,
    DetailRowComponent,

    LayoutInput,
    LayoutImageSelector,
    LayoutTextarea,
    LayoutSwitchButton,
    LayoutInfo,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onImageOutOfSize() {
      this.$toast('사이즈가 4메가가 넘습니다.');
    },

    regex(min, max) {
      return regex(min, max);
    },

    async uploadGrape(image) {
      if (!image) return null;
      if (typeof image === 'string') return image;

      const result = await this.$store.dispatch('imageUploadS3', { name: 'grape', image });

      if (!result.response) return image;
      this.$toast(result.message);

      return result.response.location;
    },

    async submit() {
      this.editable.id = this.rowData.id;
      this.editable.imgGrape = await this.uploadGrape(this.editable.imgGrape);

      const validateResult = multipleValidate([
        validate({ message: '이름', target: this.editable.name, regex: this.regex(1, 100).ko_num }),
        validate({ message: '영문 이름', target: this.editable.nameEn, regex: this.regex(1, 100).en_num }),
        validate({ message: '간단한 설명', target: this.editable.grapeDscSubtitle, regex: this.regex(1, 1000).ko_en_num }),
      ]);

      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      const result = await this.$store.dispatch('updateGrape', this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        name: this.rowData.name,
        nameEn: this.rowData.name_en,
        grapeDscSubtitle: this.rowData.grape_dsc_subtitle,
        grapeDsc: this.rowData.grape_dsc,
        imgGrape: this.rowData.img_grape,
        isChecked: this.rowData.is_checked,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/grape/detail-row/GrapeEditor.vue